// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2E8PJ","col":"styles_col__Zg4FO"};